"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useComponentErrorFocus = void 0;
var _react = require("react");
/**
 * 
 * @param {Array<string>} errorClassNames classNames of the components
 * In case of a child component with a common class name, value to be passed should be `.${parent} .${child}`
 * e.g: ['.error', 'tableValidation .message']
 */
var useComponentErrorFocus = exports.useComponentErrorFocus = function useComponentErrorFocus() {
  var errorClassNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (0, _react.useCallback)(function () {
    var _errorClassNames$map;
    var errorElement = errorClassNames === null || errorClassNames === void 0 || (_errorClassNames$map = errorClassNames.map(function (className) {
      return document.querySelector("".concat(className));
    })) === null || _errorClassNames$map === void 0 ? void 0 : _errorClassNames$map.find(function (element) {
      return !!element;
    });
    if (errorElement) {
      errorElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      errorElement.focus();
    }
  }, [errorClassNames]);
};